import '../../utils/index.mjs';
import _sfc_main from './src/breadcrumb2.mjs';
import _sfc_main$1 from './src/breadcrumb-item2.mjs';
export { breadcrumbProps } from './src/breadcrumb.mjs';
export { breadcrumbItemProps } from './src/breadcrumb-item.mjs';
import { withInstall, withNoopInstall } from '../../utils/vue/install.mjs';

const ElBreadcrumb = withInstall(_sfc_main, {
  BreadcrumbItem: _sfc_main$1
});
const ElBreadcrumbItem = withNoopInstall(_sfc_main$1);

export { ElBreadcrumb, ElBreadcrumbItem, ElBreadcrumb as default };
//# sourceMappingURL=index.mjs.map
